import axiosInstance from '../../../utils/axiosInstance';

export const fetchEmployeesApi = async (
  selectedClientId: number,
  pageIndex: number,
  orderDirection: 'ASC' | 'DESC',
  searchText: string,
) => {
  const response = await axiosInstance.post('/Admin/GetWorkerList', {
    // Backend pagination is 1-based (it clamps pageIndex < 1 to 1), while this
    // list is 0-based. Without +1, page 0 and page 1 both request offset 0, so
    // the first 10 workers repeat and later pages shift — send 1-based index.
    pageIndex: pageIndex + 1,
    pageSize: 10,
    searchString: searchText,
    orderDirection,
    companyId: selectedClientId,
  });
  return response.data;
};

export const deleteEmployeeApi = async (
  workerId: string,
  selectedClientId: number | null,
) => {
  const response = await axiosInstance.delete(
    '/Admin/RemoveWorkerFromCompany',
    {
      params: { workerId, companyId: selectedClientId },
    },
  );
  return response.status;
};
